import { render, staticRenderFns } from "./ConfirmRejectDialog.vue?vue&type=template&id=1266a2bb&scoped=true"
import script from "./ConfirmRejectDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmRejectDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmRejectDialog.vue?vue&type=style&index=0&id=1266a2bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1266a2bb",
  null
  
)

export default component.exports